import Vue from "vue";
//ant 基础组件
import "@/core/layz/components_use";
//引入本地存储和默认设置
import VueStorage from "vue-ls";
import config from "@/config/defaultSettings";
//引入自定义组件
import MultiTab from "@/components/MultiTab";
//图表
import Viser from "viser-vue";
Vue.use(Viser);
Vue.use(MultiTab);
Vue.use(VueStorage, config.storageOptions);

process.env.NODE_ENV !== "production" &&
  console.warn("[antd] PS: Antd 使用延迟加载.");
